import { render, staticRenderFns } from "./SettingDocument.vue?vue&type=template&id=26404095&"
import script from "./SettingDocument.vue?vue&type=script&lang=js&"
export * from "./SettingDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports